import { useUserRole } from '@/hooks/companyUser/useUserRole';

import { useGreyScoutEmployeeAccess } from './useIsGreyScoutEmployee';

/**
 * Whether the signed-in user is a Grey Scout Admin - an admin who works at Grey Scout - alongside
 * whether that is still being resolved.
 *
 * Deliberately not `useUserSystemRole().isGsAdmin`, which also accepts an admin of any company
 * while they are on the admin instance. Use this for anything only Grey Scout may do.
 */
export const useGreyScoutAdminAccess = () => {
  const { isAdmin } = useUserRole();

  const { isGreyScoutEmployee, isLoading } = useGreyScoutEmployeeAccess();

  return {
    isGreyScoutAdmin: isGreyScoutEmployee && isAdmin,
    isLoading,
  };
};

export const useIsGreyScoutAdmin = () => useGreyScoutAdminAccess().isGreyScoutAdmin;
